var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('img',{staticStyle:{"width":"300px"},attrs:{"alt":"Vue logo","src":require("./assets/logo.jpg")}}),_c('Index')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }